import '../scss/theme.scss';

import './modules/to-top-button';

// Import and bind bootstrap.
const bootstrap = require('bootstrap');
// import bootstrap from '././bootstrap/dist/bootstrap.bundle.min';

global.bootstrap = bootstrap;

const EVENT_BS_READY = new CustomEvent('bs-ready');
document.body.dispatchEvent(EVENT_BS_READY);


const body = document.getRootNode().body;

// menu
const header = document.getElementById('header');
const menu = document.getElementById('main-menu');
menu.addEventListener('show.bs.collapse', () => {
  header.classList.add('open');
  header.classList.add('text-bg-dark');
  body.classList.add('menu-open');
});
menu.addEventListener('hide.bs.collapse', () => {
  header.classList.remove('open');
  header.classList.remove('text-bg-dark');
  body.classList.remove('menu-open');
});

// accessibility
const accessibilityFs = document.getElementById('accessibility-fs');
let fs = 0;
const fsIcons = accessibilityFs.querySelectorAll('.icon');

accessibilityFs.addEventListener('click', () => {
  if (fs < 2) {
    fs++;
  } else {
    fs = 0;
  }
  fsIcons.forEach((icon) => {
    icon.classList.remove('active');
  });

  // update dom
  fsIcons[fs].classList.add('active');
  body.setAttribute('data-font-scale', fs);
});

// set init fs
body.setAttribute('data-font-scale', fs);


const accessibilityContrast = document.getElementById('accessibility-contrast');
accessibilityContrast.addEventListener('click', () => {
  body.classList.toggle('contrast');
});

// onscroll
let lastScroll = window.scrollY;
const progressBar = document.getElementById('progress-bar');
let documentHeight = document.documentElement.scrollHeight;
window.addEventListener('scroll', () => {
  documentHeight = document.documentElement.scrollHeight;
  // header on scroll
  if (window.scrollY > lastScroll) {
    if (!header.classList.contains('scrolled')) {
      header.classList.add('scrolled');
    }
  } else if (header.classList.contains('scrolled') || window.scrollY <= 40) {
    header.classList.remove('scrolled');
  }
  lastScroll = window.scrollY;

  // scroll progressbar
  let scrollPercentage = (window.scrollY / (documentHeight - window.innerHeight) * 100).toFixed(1);
  progressBar.setAttribute('aria-valuenow', scrollPercentage);
  progressBar.children[0].style.width = `${scrollPercentage}%`;

  // if
  if (document.querySelector('.module-icon-sidebar')) {
    document.querySelector('.module-icon-sidebar').classList.remove('open');
  }
});

// filter-tabs/search
const filterTabs = document.querySelectorAll('#filter-navigation-tabs .btn');
const filterTitles = document.querySelectorAll('[data-bs-tabs-title]');
filterTabs.forEach((tab) => {
  tab.addEventListener('show.bs.tab', (e) => {
    let tabTarget = e.target.dataset.bsTarget;
    filterTitles.forEach((title) => {
      title.classList.remove('show');
    });
    document.querySelector('[data-bs-tabs-title="#' + e.target.id + '"]').classList.add('show');
    if (tabTarget === '#search-tab-pane') {
      console.log('SEARCH');
    }
  });
});


const sidebar = document.querySelector('.module-icon-sidebar');
if (sidebar) {
  const docClick = function (e) {
    if (e.target !== sidebar) {
      sidebar.classList.remove('open');
    }
    document.removeEventListener('click', docClick);
  };

  sidebar.querySelector('.share-btn').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    sidebar.classList.toggle('open');

    if (sidebar.classList.contains('open')) {
      document.addEventListener('click', docClick);
    } else {
      document.removeEventListener('click', docClick);
    }
  });
}

// newsletter
const newsletter = document.querySelector('.module-newsletter');
if (newsletter && window.innerWidth > 991) {
  const btn = newsletter.querySelector('.btn');

  if (newsletter.classList.contains('follow-cursor')) {
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;
    const easing = 0.1; // Easing-Faktor (0.1 = smooth, kleinere Werte = langsamer)

    function updatePosition() {
    // Berechne die Differenz zwischen aktueller und Zielposition
      const dx = targetX - currentX;
      const dy = targetY - currentY;

      // Wende Easing an
      currentX += dx * easing;
      currentY += dy * easing;

      // Positioniere den Button
      btn.style.transform = `translate(${currentX}px, ${currentY - 40}px)`;

      // Animation fortsetzen, wenn Maus im Container
      if (newsletter.matches(':hover')) {
        requestAnimationFrame(updatePosition);
      }
    }

    newsletter.addEventListener('mouseenter', () => {
    // Starte die Animation
      requestAnimationFrame(updatePosition);
    });

    newsletter.addEventListener('mousemove', (e) => {
    // Berechne die Zielposition relativ zum Newsletter-Container
      const rect = newsletter.getBoundingClientRect();
      targetX = e.clientX - rect.left - btn.offsetWidth / 2; // Zentriert unter Cursor
      targetY = e.clientY - rect.top - btn.offsetHeight / 2;
    });

    newsletter.addEventListener('mouseleave', () => {
    // Zurück zur Ausgangsposition mit Easing
    // targetX = 0;
    // targetY = 0;
      requestAnimationFrame(updatePosition);
    });

    btn.style.position = 'absolute';
    btn.style.transition = 'all 0.1s ease-out'; // Zusätzliches Smoothing
  } else {
    btn.style.left = 'calc(100vw / 2 + max(2vw, 20vw))';
  }
}
